import React from "react";
import PropTypes from "prop-types";
import StereotypesStore from "data/StereotypesStore";
import TableStore from "data/TableStore";
import {
    canDeleteSuperRecord,
    canMergeSuperRecord,
} from "data/selectors/superRecords";
import NavigatorStore from "data/NavigatorStore";
import GlobalMergeButton from "lib/merge/mergebutton/GlobalMergeButton";
import useFluxStore from "@armus/use-flux-store";
import lockStore, { lockShape } from "data/lockStore";
import LockMessage from "lib/lock/LockMessage";
import Dispatcher from "Dispatcher";
import SuperRecordActions from "data/SuperRecordActions";

export class EntityHeader extends React.Component {
    render() {
        const {
            fluxContext,
            label,
            detailString,
            allowDelete = false,
            allowMerge = false,
            typeLabel,
            onClick,
            pesslock,
        } = this.props;
        return (<h1 className="top">
            <span className="entity-label">{label}</span>
            &nbsp;
            <small>
                {detailString &&
                <span className="entity-detail">{detailString}</span>
                }
                &nbsp;
                <div className="entity-actions">
                    {allowMerge && <GlobalMergeButton
                        fluxContext={fluxContext}
                    />}
                    {allowDelete && onClick && <button
                        className="btn btn-small btn-delete deleteRoot btn-dark"
                        onClick={onClick}
                    >
                        <span /> Delete {typeLabel}
                    </button>}
                    <LockMessage lock={pesslock} />
                </div>
            </small>
        </h1>);
    }
}

EntityHeader.propTypes = {
    fluxContext: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onMergeClick: PropTypes.func,
    detailString: PropTypes.string,
    allowDelete: PropTypes.bool,
    allowMerge: PropTypes.bool,
    typeLabel: PropTypes.string,
    pesslock: PropTypes.shape(lockShape),
};

export const FluxEntityHeader = props => {
    const {fluxContext} = props;
    const state = useFluxStore(() => {
        const magicState = NavigatorStore.getMagicState(fluxContext);
        if (magicState == null) return {gonk: true};
        const sp = TableStore.getStereotypeProxy(magicState.key, magicState.id);
        const rs = NavigatorStore.getRecordState(fluxContext);
        if (rs != null) sp.withEntityContext(rs.key);
        return {
            fluxContext,
            label: sp.getLabel(),
            onClick: () => {
                Dispatcher.contextDispatch(fluxContext, {
                    type: SuperRecordActions.DELETE_RECORD,
                    key: magicState.key,
                    id: magicState.id,
                });
            },
            detailString: sp.getDetailString(),
            allowDelete: canDeleteSuperRecord(sp),
            allowMerge: canMergeSuperRecord(sp),
            typeLabel: sp.stereoInfo.name,
            pesslock: lockStore.getPessLock(fluxContext),
        };
    }, [
        StereotypesStore,
        TableStore,
        NavigatorStore,
        lockStore,
    ], [fluxContext]);
    return state.gonk ? null : <EntityHeader {...props} {...state} />;
};

FluxEntityHeader.propTypes = {
    fluxContext: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/views/EntityHeader.js